import React, {useEffect, useMemo, useState} from 'react';
import {toast} from 'react-toastify';
import {css} from 'glamor';
import AuthService from '../Services/AuthService';
import './InvitacionReclutamiento.css';

const preregistroBaseLink = `${window.location.origin}/preregistro/`;
const userInfoErrorMsg = 'Tu QR se ha vencido, para volver a generarlo cierra y abre sesión.\nSi persiste el problema consulta con Soporte Técnico';
const profileValidationErrorMsg = 'Ocurrió un problema al validar tu perfil, intenta nuevamente más tarde.';
const tmLiteValidationErrorMsg = 'Debido a tu promoción TM LITE no tienes disponible el código de reclutamiento.\nPara más información contacta con tu Gerente.';

export default function InvitacionReclutamiento() {
  const [preregistroLink, setPreregistroLink] = useState('');
  const [hasUserInfoError, setHasUserInfoError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(userInfoErrorMsg);
  const [isLoading, setIsLoading] = useState(true);

  const qrCodeUrl = useMemo(() => {
    if (!preregistroLink) {
      return '';
    }

    return `https://api.qrserver.com/v1/create-qr-code/?size=320x320&data=${encodeURIComponent(preregistroLink)}`;
  }, [preregistroLink]);

  const alerts = (msg) => {
    toast(msg, {
      className: css({
        background: '#00AC46',
        color: 'white',
      }),
      progressClassName: css({
        background: '#00AC46',
      }),
    });
  };

  useEffect(() => {
    const currentUser = AuthService.getCurrentUser();

    if (!currentUser || !currentUser.correo || !currentUser.idu) {
      setErrorMessage(profileValidationErrorMsg);
      setHasUserInfoError(true);
      setIsLoading(false);
      return;
    }

    AuthService.NSgetDataEmployee(currentUser.idu)
      .then((validationResp) => {
        const isValidPresenter = validationResp && validationResp.data && validationResp.data.success === true;

        if (!isValidPresenter) {
          const validationError = validationResp && validationResp.data ? validationResp.data.error : '';

          if (validationError === 'Reclutador TM Lite') {
            setErrorMessage(tmLiteValidationErrorMsg);
          } else {
            setErrorMessage(profileValidationErrorMsg);
          }

          setHasUserInfoError(true);
          return;
        }

        return AuthService.getUserNSid(currentUser.correo)
          .then((resp) => {
            if (resp && resp.data && resp.data.success === true && resp.data.netsuiteid) {
              setPreregistroLink(`${preregistroBaseLink}?&recid=${resp.data.netsuiteid}`);
              setHasUserInfoError(false);
              setErrorMessage(userInfoErrorMsg);
              return;
            }

            setErrorMessage(userInfoErrorMsg);
            setHasUserInfoError(true);
          });
      })
      .catch(() => {
        setErrorMessage(profileValidationErrorMsg);
        setHasUserInfoError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const copyLink = async () => {
    if (!preregistroLink) {
      return;
    }

    try {
      await navigator.clipboard.writeText(preregistroLink);
    } catch (error) {
      const fallbackInput = document.createElement('input');
      fallbackInput.value = preregistroLink;
      document.body.appendChild(fallbackInput);
      fallbackInput.select();
      document.execCommand('copy');
      document.body.removeChild(fallbackInput);
    }

    alerts('Link copiado a portapapeles');
  };

  const signOutAndGoHome = () => {
    AuthService.logout();
    window.location.href = '/';
  };

  const goHome = () => {
    window.localStorage.setItem('titleToolbar', 'Inicio');
    window.location.href = '/inicio';
  };

  return (
    <div className="inv-qr-page">
      <div className="inv-qr-card">
        <div className="inv-qr-hero" />

        <div className="inv-qr-content">
          {!isLoading && hasUserInfoError ? (
            <div className="inv-qr-user-error-wrap">
              <div className="inv-qr-user-error">{errorMessage}</div>
              {errorMessage === tmLiteValidationErrorMsg ? (
                <button type="button" className="inv-qr-logout-button" onClick={goHome}>
                  Regresar
                </button>
              ) : (
                <button type="button" className="inv-qr-logout-button" onClick={signOutAndGoHome}>
                  Cerrar Sesión
                </button>
              )}
            </div>
          ) : null}

          {!isLoading && !hasUserInfoError ? (
            <>
              <div className="inv-qr-main-grid">
                <div className="inv-qr-text-column">
                  <h1 className="inv-qr-title">Las mejores historias siempre se comparten</h1>

                  <div className="inv-qr-share-row">
                    <span className="inv-qr-share-text">Compartir liga</span>
                    <button type="button" className="inv-qr-copy-button" onClick={copyLink} aria-label="Copiar liga de preregistro">
                      <img src="/assets/img/icons/copy_white_26.png" alt="Copiar liga" />
                    </button>
                  </div>
                </div>

                <div className="inv-qr-code-stage">
                  <img className="inv-qr-code" src={qrCodeUrl} alt="QR de preregistro" />

                  <img className="inv-qr-blade inv-qr-blade-top-left" src="/assets/img/blade_black.png" alt="" aria-hidden="true" />
                  <img className="inv-qr-blade inv-qr-blade-top-right" src="/assets/img/blade_black.png" alt="" aria-hidden="true" />
                  <img className="inv-qr-blade inv-qr-blade-bottom-left" src="/assets/img/blade_black.png" alt="" aria-hidden="true" />
                  <img className="inv-qr-blade inv-qr-blade-bottom-right" src="/assets/img/blade_black.png" alt="" aria-hidden="true" />
                </div>
              </div>

              <img className="inv-qr-footer-logo" src="/assets/img/thermomix_header_2023.png" alt="Thermomix" />
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
